export const parseInterviewTypes = (value, defaultValue = ["TEXT"]) => {
  if (typeof value === "string") {
    try {
      const parsed = JSON.parse(value);
      return Array.isArray(parsed) ? parsed : defaultValue;
    } catch (e) {
      return defaultValue;
    }
  }
  if (value === null || value === undefined) {
    return defaultValue;
  }
  if (Array.isArray(value)) {
    return value;
  }
  return defaultValue;
};

export const ensureInterviewTypesArray = (value, defaultValue = ["TEXT"]) => {
  return Array.isArray(value) ? value : defaultValue;
};

export const isInterviewTypePickerEnabled = () => {
  if (process.env.NODE_ENV === 'development') return true;
  const url = process.env.REACT_APP_FRONTEND_URL || '';
  return url.includes('frontend-dev') || url.includes('frontend-staging');
};

export const isVoiceFeatureEnabled = () => {
  if (process.env.NODE_ENV === 'development') return true;
  const url = process.env.REACT_APP_FRONTEND_URL || '';
  return url.includes('frontend-dev') || url.includes('frontend-staging');
};
